/**
 * Chinese FAQ Translations
 * FAQ翻译模块 - 中文
 */

import type { FaqTranslations } from '../../types';

export const zhFaq: FaqTranslations = {
  title: '常见问题',
  subtitle: '查找关于红外取暖器的常见问题答案',
  contactTitle: '找不到您要找的答案？',
  contactButton: '联系我们',
  questions: {
    whyChoose: {
      title: '为什么选择远红外辐射取暖器？',
      desc1: '超越转换效率：虽然远红外取暖器的表面能量转换率可能低于热泵，但实际节能效果和用户体验却截然不同。远红外取暖器设计为直接向房间内的物体和人供热，最大限度地减少热量损失，确保温暖到达最需要的地方。',
      desc2: '强劲且节能：功率范围从1800W到3200W，这些取暖器能够提供大量热量。然而，它们的高效散热分布意味着您可以用更少的能耗达到所需的温暖，最终节省电费。',
      desc3: '增强的舒适体验：远红外热量以其深入材料和生物组织的能力而闻名，提供更均匀舒适的温暖。不同之处在于您将成为空间中的另一个"火源"，而不是空气炸锅中的鸡块。',
      desc4: '舒适体验的多功能取暖解决方案：在特别寒冷的日子里，远红外辐射取暖器可以与其他取暖系统配合使用，确保您的空间持续温暖舒适。',
    },
    getPrice: {
      title: '如何获取远红外取暖器的价格？',
      desc: '您可以点击我们的联系我们页面，留言告诉我们您需要的型号和数量。我们将根据您的具体需求提供报价。',
    },
    services: {
      title: '你们提供哪些服务？',
      item1: '标准化样品（2件起）快速发货，3-15天，可选插头有限',
      item2: '标准化中等订单（20件起），15-30天，轻度定制（标志、产品包装、运输包装）',
      item3: '标准化产品大批量订单（300~2000件以上），45-60天，可选增值服务（特殊外观、额外功能、特殊标准）',
      note: '以上服务适用于电暖器产品。',
    },
    energyEfficient: {
      title: '远红外取暖器更节能吗？',
      desc1: '远红外取暖器将电能转换为远红外辐射，然后被房间内的物体吸收，从而升高温度。远红外取暖器的效率取决于几个因素，包括房间大小、隔热性能和取暖器类型平均而言，远红外取暖器比传统取暖系统更节能，因为它们直接加热物体，减少了对流造成的能量损失。',
      desc2: '然而，实际能源效率可能因使用方式和环境因素而异。建议咨询产品规格和客户评价以确定能源效率。',
    },
    coveringArea: {
      title: 'JH取暖器的覆盖面积是多少？',
      desc: '覆盖面积取决于房间大小、隔热条件和天花板高度。我们的取暖器根据其功率规格设计，以有效加热空间。',
    },
    howWork: {
      title: 'JH红外辐射取暖器是如何工作的？',
      desc1: '传统的对流取暖器首先加热循环的空气。我们的红外取暖板首先加热人和物体，而不是周围的空气。红外线在短时间内加热皮肤，温暖的光辉通过全身血液循环传导。因此您在周围空气较凉的情况下也能很快感受到舒适的温暖。',
      benefit1: '它通过远红外方式直接温暖人体，而不是浪费大量能量来加热空气。',
      benefit2: '与其他辐射取暖器相比，由于采用新技术，我们的取暖器具有更高的电热转换效率。',
      benefit3: '它比其他电取暖器更舒适。',
      desc2: '该图示展示了传统对流取暖器与红外辐射取暖器的区别。',
    },
    operatingCost: {
      title: 'JH红外辐射取暖器的运行成本是多少？',
      desc1: '假设电价为每千瓦时0.35欧元，JH取暖器的运行成本从每小时0.63欧元（1800W）到每小时1.12欧元（3200W）不等。',
      desc2: '相比之下，效率较低的"蘑菇型"户外取暖器功率为13千瓦，每小时运行成本为4.55欧元，即最强大型号的四倍。',
    },
    difference13A14A: {
      title: '13A取暖器和14A取暖器有什么区别？',
      desc: '区别仅在于辐射面板设计，内部加热元件和结构相同，加热效率也相同。',
    },
    installationHeight: {
      title: '最佳安装高度是多少？',
      desc: '建议安装高度为1.8至2.5米。',
    },
    whyShortWave: {
      title: '为什么选择短波？',
      desc1: '基本上，波长越短，越容易穿过空气。短波红外线通过加热遇到的物体来产生热量，而不会加热周围的空气。即使有效且即时加热，无需预热。',
      desc2: '这种作用方式的一个很好的例子是当一个人从阴凉处走到阳光下时产生的效果。虽然环境温度相同，但在直接阳光辐射下，他们感觉温度明显更温暖。',
    },
  },
};
